import React, { useEffect, useState } from "react";
import SingleItem from "./SingleItem";
import Skeleton from "react-loading-skeleton";
import NewCoinSingleItem from "./NewCoinSingleItem";

const Crypto = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      `https://api.wlfmobile.com/api/user/trade/market/crypto/currency/mobile/filter/view`,
      {
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setLoading(false);
      });
  }, []);


  const [NewCoinData, setNewCoinData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/user/new/coin/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setNewCoinData(data.data);
      });
  }, []);



  if (loading) {
    return;
  }

  return (
    <>
      <div className="markets-coin-lists">
        {data.map((data, index) => (
          <SingleItem data={data} key={data?._id} index={index}></SingleItem>
        ))}
        {NewCoinData.map((data, index) => (
          <NewCoinSingleItem data={data} key={data?._id} index={index}></NewCoinSingleItem>
        ))}

      </div>
    </>
  );
};


//  (
//       <section className="mobile-version">
//         <div className="Mobile-version-slider">
//             <Skeleton count={15} height={35} />
//         </div>
//       </section>
//     );

export default Crypto;
